import React from 'react';
import { TextField, TextFieldProps } from '@material-ui/core';
import NumberFormat from 'react-number-format';

interface PhoneNumberFormatProps {
  inputRef: (instance: NumberFormat | null) => void;
  name: string | undefined;
  onChange: (event: {
    target: { name: string | undefined; value: string };
  }) => void;
}

const PhoneNumberFormat: React.FC<PhoneNumberFormatProps> = ({
  inputRef,
  name,
  onChange,
  ...rest
}) => {
  return (
    <NumberFormat
      className='Jane'
      {...rest}
      format='(###) ###-####'
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: name,
            value: values.value,
          },
        });
      }}
    />
  );
};

const PhoneNumberTextField: React.FC<TextFieldProps> = (props) => {
  return (
    <TextField
      {...props}
      InputProps={{
        inputComponent: PhoneNumberFormat as any,
      }}
    />
  );
};

export default PhoneNumberTextField;
